import React from "react";

const DraggingContext = React.createContext(null);

export default DraggingContext;
